<template>
    <Dialog
        :is-popup="isOpen"
        @close="close"
        :scrollable="true"
    >
        <div class="activity-create-popup">
            <h1>
                Предложить встречу
            </h1>
            <div class="pair">
                <div class="avatar"></div>
                <div class="info">
                    <div class="name">{{ pairFullName }}</div>
                    <div class="role">{{ getRoleName }}</div>
                </div>
            </div>
            <div class="form">
                <ModelString
                    label="Тема"
                    v-model="item.theme"
                    @change="validation.theme.valid = true"
                    :valid="validation.theme.valid"
                ></ModelString>
                <ModelTextArea
                    label="Описание"
                    v-model="item.description"
                    @change="validation.description.valid = true"
                    :valid="validation.description.valid"
                />
                <ModelISO
                    label="Дата"
                    v-model="item.date"
                    @change="validation.date.valid = true"
                    :valid="validation.date.valid"
                />
                <ModelTime
                    class="time"
                    label="Время"
                    v-model="item.time"
                    @change="validation.time.valid = true"
                    :valid="validation.time.valid"
                />
                <ModelAutoComplete
                    label="Место"
                    v-model="item.address"
                    :vizKeyPath="[['value']]"
                    :items="autoCompleteAddresses"
                    @debounce-end="getAutocompleteAddress"
                />
            </div>
            <div class="buttons">
                <Button
                    class="btn"
                    outline
                    @click="create"
                >Отправить</Button>
            </div>
        </div>
    </Dialog>
</template>

<script>
import Dialog from '../../../../UI/Dialog';
import Button from '../../../../UI/Button';
import ModelString from '../../../../UI/models/ModelString';
import ModelTextArea from '../../../../UI/models/ModelTextArea';
import ModelISO from '../../../../UI/models/ModelISO';
import ModelTime from '../../../../UI/models/ModelTime';
import ModelAutoComplete from '../../../../UI/models/ModelAutoComplete';
import {validation} from '../../../../../tools/comparer';
import {mapActions, mapState} from 'vuex';
import {post, qs} from '../../../../../tools/http';

const actions = [
    'createMeeting',
];

export default {
    name: 'MeetingCreate',
    props: {
        isOpen: {
            type: Boolean,
            required: true,
        },
    },
    data: () => ({
        item: {},
        autoCompleteAddresses: [],
        validation: {
            theme: {
                reg: "empty",
                valid: true,
            },
            description: {
                reg: "empty",
                valid: true,
            },
            date: {
                reg: "date",
                valid: true,
            },
            time: {
                reg: "time",
                valid: true,
                validate: (v) => Array.isArray(v)
                    && v.length === 2
                    && v.every(v => !isNaN(parseInt(v))),
            },
        },
    }),
    components: {
        Dialog,
        Button,
        ModelString,
        ModelTextArea,
        ModelISO,
        ModelTime,
        ModelAutoComplete,
    },
    watch: {
        isOpen() {
            this.setDefaults();
        },
    },
    computed: {
        ...mapState('mentoring', [
            'role',
            'pair',
        ]),
        getRoleName() {
            return this.role === 'mentor' ? 'Наставляемый' : 'Наставник';
        },
        pairFullName() {
            if (!this.pair) return '';
            return `${this.pair.surname} ${this.pair.name}`;
        },
    },
    methods: {
        ...mapActions('mentoring/activities', actions),
        setDefaults() {
            this.item = {
                theme: '',
                description: '',
                date: null,
                time: [null, null],
            };
        },
        async create() {
            Object.keys(this.validation).forEach((key) => {
                this.validation[key].valid = true;
            });
            let errors = validation(this.item, this.validation);
            if (errors.length > 0) {
                errors.forEach(key => {
                    this.validation[key].valid = false;
                });
            } else {
                let item = { ...this.item };
                let [year, month, day] = this.item.date.split('-').map(v => parseInt(v));
                let [hours, minutes] = this.item.time;
                item.datetime = new Date(year, month - 1, day, hours, minutes).toISOString();
                item.location = item.address ? item.address.value : null;
                delete item.date;
                delete item.time;
                delete item.address;
                await this.createMeeting(item);
                this.close();
            }
        },
        close() {
            this.$emit('change', false);
        },
        async getAutocompleteAddress(inputObj) {
            let postParams = [
                "dadata",
                "search",
                qs({ query: inputObj.value, type: "address" }),
                true,
                { "content-type": "application/x-www-form-urlencoded" },
            ];
            let res = await post(...postParams);
            this.autoCompleteAddresses = res.suggestions;
        },
    },
    model: {
        prop: 'isOpen',
        event: 'change',
    },
};
</script>

<style lang="scss">
    @import '../../../../../styles/rem';

    .activity-create-popup {
        h1 {
            font-style: normal;
            font-size: rem(24);
            line-height: rem(32);
            text-align: center;
            color: #2A2626;
            margin-top: 0;

            @include on-mobile {
                font-size: mrem(24);
                line-height: mrem(32);
            }
        }
        p {
            font-size: rem(18);
            line-height: rem(26);
            text-align: center;
            color: #2A2626;

            @include on-mobile {
                font-size: mrem(18);
                line-height: mrem(26);
            }
        }

        .pair {
            display: flex;
            flex-direction: row;
            margin: rem(24) 0 rem(32);

            @include on-mobile {
                margin: mrem(24) 0 mrem(32);
            }

            .avatar {
                width: rem(56);
                height: rem(56);
                border-radius: rem(28);
                background-image: url("../../../../../assets/images/avatar_placeholder.png");
                background-size: contain;
                background-repeat: no-repeat;
                margin-right: rem(16);

                @include on-mobile {
                    border-radius: mrem(28);
                    width: mrem(56);
                    height: mrem(56);
                    margin-right: mrem(16);
                }
            }
            .name {
                font-weight: 600;
                font-size: rem(16);
                line-height: rem(24);
                color: black;
                margin-bottom: rem(8);

                @include on-mobile {
                    font-size: mrem(16);
                    line-height: mrem(24);
                    margin-bottom: mrem(8);
                }
            }
            .role {
                font-weight: 600;
                font-size: rem(14);
                line-height: rem(20);
                text-align: center;
                color: #FFFFFF;
                background: #EF627D;
                border-radius: rem(100);
                padding: rem(2) rem(12);

                @include on-mobile {
                    font-size: mrem(14);
                    line-height: mrem(20);
                    border-radius: mrem(100);
                    padding: rem(2) mrem(12);
                }
            }
        }
        .btn {
            width: 100%;

            @include on-mobile {
                background: #4663AB;
                color: white;
                border-radius: mrem(4);
            }
        }
        .buttons {
            display: flex;
            flex-direction: row;
            justify-content: space-around;

            @include on-mobile {
                flex-wrap: wrap;
                flex-direction: column-reverse;
            }
        }
    }
</style>

<style lang="scss" scoped>

</style>